import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import Constant from '@/common/constant/Constant';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export const DialogConfirmForceCreateTicket = props => {
    // Re-render when the translation dictionary loads/updates
    useTranslationSubscription();

    const { isOpen, setIsOpen, onSubmit } = props;
    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }

        setIsOpen(false);
    };

    const onHandlerConfirm = () => {
        onSubmit();
        setIsOpen(false);
    };

    return (
        <Dialog
            open={isOpen}
            onClose={(event, reason) => onCloseConfirm(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">
                    {trI18n(Constant.EXISTS_B2B_CUSTOMER_ERROR)}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    onClick={onHandlerConfirm}
                    className="confirm-dialog-button btn-hg32 btn-handle-delete-user-agree"
                    variant="contained"
                >
                    {trI18n('COMBTN002')}
                </Button>
                <Button
                    className="confirm-dialog-button btn-hg32"
                    variant="contained"
                    onClick={(event, reason) => onCloseConfirm(event, reason)}
                >
                    {trI18n('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
